// React
import { useCallback } from 'react';

// Antd
import { Table } from 'antd';

// Interfaces
import { IBaseTableBodyProps } from './interfaces';

const BaseTableBody = ({ onChangeTable, isBgPrimaryHeader, ...rest }: IBaseTableBodyProps) => {
  /**
   * @description Watch any change in table
   *
   * @param {any} event
   *
   * @return {void} void
   */
  const onChange = useCallback(
    ({ pagination, filters, sorter }: any) => {
      if (onChangeTable) {
        onChangeTable({ name: 'table', value: { pagination, filters, sorter } });
      }
    },
    [onChangeTable],
  );

  return (
    <Table
      onChange={onChange}
      rowKey={rest.rowKey || 'id'}
      pagination={false}
      scroll={{ x: 1200 }}
      {...rest}
      className={`custom-table ${isBgPrimaryHeader ? 'header-primary' : ''} ${rest.className}`}
    />
  );
};

export { BaseTableBody };
